<template>
  <div class="d-flex justify-content-between">
    <div class="d-flex gap-2">
      <button @click="$emit('tambah')" v-if="show_tambah_btn" class="btn btn-sm btn-success mr-2">Tambah</button>
      <select v-model="form.limit" name="page" class="form-select form-select-sm" @change="handleChanges">
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="500">500</option>
        <option value="1000">1000</option>
      </select>
      <label class="fw-normal m-0 mt-1" style="white-space: nowrap;">Total data : {{ this.data.total }}</label>
    </div>
    <div class="d-flex gap-2">
      <input type="text" class="form-control form-control-sm" placeholder="Cari data..." v-model="form.q" @change="handleChanges">
      <button class="btn btn-sm btn-success" type="button" v-if="show_filter_btn" @click="$emit('filter')">
        <Icon :icon="['fa', 'filter']" />
      </button>
    </div>
  </div>
  <hr>
  <slot></slot>

  <nav class="mt-4">
    <ul class="pagination justify-content-center">
      <li v-for="(page, index) in this.data.links" :key="`page-link-${index}`" class="page-item" :class="{ 'active': page.active }">
        <Link class="page-link" v-if="(page.url + '').split('/admin')[1]" :href="'/admin' + (page.url + '').split('/admin')[1]" v-html="page.label"></Link>
        <a class="page-link" v-else v-html="page.label"></a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['data', 'show_tambah_btn', 'show_filter_btn'],
  data() {
    return {
      form: {
        q: '',
        limit: 25
      }
    }
  },
  methods: {
    handleChanges() {
      this.$inertia.get('', this.form);
    }
  },
  mounted() {
    const query = this.data.query;
    if(query) {
      Object.keys(this.form).map(key => {
        this.form[key] = query[key];
      });
    }

    this.form.limit = this.data.per_page;
  }
}
</script>